/** The product's name (backlog §7): page title, auth and dashboard headers, invitation emails, watermark. */
export const PRODUCT_NAME = 'Obsession Studio Jam';
